import { parseBooleanString, parseInteger } from '../../../util/utility';
import { CXoneAgentEvent } from '../agent/cxone-agent-event';
/**
 * Model class for agent session start event
 */
export class AgentSessionStartEvent extends CXoneAgentEvent {
  /**
   * @remarks - 
   */
  public busNo!: string;

  /**
   * @remarks - 
   */
  public agentId!: string;

  /**
   * @remarks - 
   */
  public stationId!: string;

  /**
   * @remarks - 
   */
  public stationPhoneNumber!: string;

  /**
   * @remarks - 
   */
  public stationCallerId!: string;

  /**
   * @remarks - 
   */
  public sessionId!: string;

  /**
   * @remarks - 
   */
  public dialerCampaign!: string;

  /**
   * @remarks - 
   */
  public dialerCampaignStartTime!: Date;

  /**
   * @remarks - 
   */
  public supervisorPermissionLevel!: number;

  /**
   * @remarks - 
   */
  public canMask!: boolean;

  /**
   * @remarks - 
   */
  public agentSchedulePermission!: string;

  /**
   * @remarks - 
   */
  public scoreRecordingsPermission!: boolean;

  /**
   * @remarks - 
   */
  public hideAgentStatePermission!: string;

  /**
   * @remarks - 
   */
  public clientConnectorPort!: number;

  /**
   * @remarks - 
   */
  public canMultiPartyConference!: boolean;

  /**
   * @remarks - 
   */
  public maxConcurrentChats!: number;

  /**
   * @remarks - 
   */
  public canRecord!: boolean;

  /**
   * @remarks - 
   */
  public enabledForMCH!: boolean;

  /**
   * @remarks - 
   */
  public useCustomerCard!: boolean;

  /**
   * @remarks - 
   */
  public agentUUId!: string;

  /**
   * @remarks - 
   */
  public entityMode!: boolean;

  /**
   * The parse method will take the data object and assign the values to the AgentSessionStartEvent class properties
   * @param data - Data object received
   * @example -
   * ```
   *parse(data);
   * ```
   */
  public parse(data: { [key: string]: string }): void {
    this.iisHost = data.IISHost,
      this.vcHost = data.VCHost,
      this.busNo = data.BusNo,
      this.agentId = data.AgentId,
      this.stationId = data.StationId,
      this.stationPhoneNumber = data.StationPhoneNumber,
      this.stationCallerId = data.StationCallerId,
      this.sessionId = data.SessionId,
      this.dialerCampaign = data.DialerCampaign,
      this.dialerCampaignStartTime = new Date(data.DialerCampaignStartTime),
      this.supervisorPermissionLevel = parseInteger(data.SupervisorPermissionLevel),
      this.canMask = parseBooleanString(data.CanMask),
      this.agentSchedulePermission = data.AgentSchedulePermission,
      this.scoreRecordingsPermission = parseBooleanString(data.ScoreRecordingsPermission),
      this.hideAgentStatePermission = data.HideAgentStatePermission,
      this.clientConnectorPort = parseInteger(data.ClientConnectorPort),
      this.canMultiPartyConference = parseBooleanString(data.CanMultiPartyConference),
      this.maxConcurrentChats = parseInteger(data.MaxConcurrentChats),
      this.canRecord = parseBooleanString(data.CanRecord),
      this.enabledForMCH = parseBooleanString(data.EnabledForMCH),
      this.useCustomerCard = parseBooleanString(data.UseCustomerCard),
      this.agentUUId = data.AgentUUId,
      this.entityMode = parseBooleanString(data.EntityMode);
  }
}
